// noinspection TypeScriptValidateJSTypes
// noinspection TypeScriptValidateJSTypes
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { catchError, EMPTY, first, Observable, switchMap, throwError } from 'rxjs';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';

import { clearCurrentUser, IAppState } from '@bms-client/store';
import { Store } from '@ngrx/store';

@Injectable({ providedIn: 'root' })
export class AddAuthTokenInterceptor implements HttpInterceptor {
    private readonly authToken$;

    public constructor(
        private readonly store: Store<IAppState>, //
        private readonly router: Router,
    ) {
        this.authToken$ = this.store.select((s) => s.currentUser.authToken).pipe(first());
    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return this.authToken$.pipe(
            switchMap((authToken) => {
                if (authToken) {
                    req = req.clone({ setHeaders: { 'X-Token': authToken } });
                }

                return next.handle(req).pipe(
                    catchError((err: any) => {
                        if (err instanceof HttpErrorResponse) {
                            if (err.status === 401 && !err.url?.includes('login')) {
                                return fromPromise(this.clearStorageAndReload()) //
                                    .pipe(switchMap(() => EMPTY));
                            }
                        }

                        return throwError(err);
                    }),
                );
            }),
        );
    }

    private async clearStorageAndReload() {
        this.store.dispatch(clearCurrentUser());

        await this.router.navigateByUrl('/login');

        //window.location.reload();
    }
}
